/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type SbRespBrowseHeader_itemSearch = {
    readonly pageType: string | null;
    readonly meta: {
        readonly header: string | null;
    } | null;
    readonly " $refType": "SbRespBrowseHeader_itemSearch";
};
export type SbRespBrowseHeader_itemSearch$data = SbRespBrowseHeader_itemSearch;
export type SbRespBrowseHeader_itemSearch$key = {
    readonly " $data"?: SbRespBrowseHeader_itemSearch$data;
    readonly " $fragmentRefs": FragmentRefs<"SbRespBrowseHeader_itemSearch">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "SbRespBrowseHeader_itemSearch",
  "type": "ItemSearchQueryConnection",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "pageType",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "meta",
      "storageKey": null,
      "args": null,
      "concreteType": "MetaData",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "header",
          "args": null,
          "storageKey": null
        }
      ]
    }
  ]
};
(node as any).hash = 'df9a6382a85f3b62d385a5c88149c62b';
export default node;
